<!-- 巡检计划管理 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <!-- 自定义新增、批量操作按钮 -->
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddNew">
          新增
        </el-button>
        <el-button type="success" icon="el-icon-check" :disabled="!ids" size="small" @click="handleBatchEnable">
          批量启用
        </el-button>
        <el-button type="warning" icon="el-icon-close" :disabled="!ids" size="small" @click="handleBatchDisable">
          批量禁用
        </el-button>
        <el-button type="primary" icon="el-icon-download" size="small" :loading="exportLoading" @click="handleExport">
          导出
        </el-button>
      </template>

      <!-- 自定义状态列 -->
      <template slot="status" slot-scope="{ row }">
        <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small" effect="light">
          {{ row.status === 1 ? "启用" : "禁用" }}
        </el-tag>
      </template>

      <!-- 自定义操作列 - 包含编辑和启用/禁用功能 -->
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-edit" @click="handleEdit(row)" style="color: #409eff; margin-right: 8px">
          编辑
        </el-button>
        <el-button type="text" size="small" :icon="row.status === 1 ? 'el-icon-close' : 'el-icon-check'" @click="handleToggleStatus(row)" :style="{ color: row.status === 1 ? '#f56c6c' : '#67c23a' }">
          {{ row.status === 1 ? "禁用" : "启用" }}
        </el-button>
      </template>
    </avue-crud>

    <!-- 新增/编辑巡检计划弹窗 -->
    <el-dialog :title="isEditMode ? '编辑巡检计划' : '新增巡检计划'" :visible.sync="addDialogVisible" width="800px" :close-on-click-modal="false" :close-on-press-escape="false" :modal="true" :modal-append-to-body="true" :append-to-body="true"
      :z-index="3000">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="120px" class="add-form">
        <!-- 基本信息 -->
        <div class="form-section">
          <div class="section-title">
            <span class="required">基本信息*</span>
          </div>

          <el-form-item label="计划名称" prop="planName">
            <el-input v-model="addForm.planName" placeholder="请输入计划名称" maxlength="50" show-word-limit />
          </el-form-item>

          <el-form-item label="执行周期" prop="executeCycle">
            <el-radio-group v-model="addForm.executeCycle" @change="handleCycleChange">
              <el-radio label="daily">每天</el-radio>
              <el-radio label="weekly">每周</el-radio>
              <el-radio label="monthly">每月</el-radio>
              <el-radio label="custom">自定义周期</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 每天执行时间 -->
          <el-form-item v-if="addForm.executeCycle === 'daily'" label="执行时间" prop="dailyStartTime">
            <el-time-picker v-model="addForm.dailyStartTime" placeholder="开始时间" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 150px; margin-right: 10px" />
            <span style="margin: 0 10px">至</span>
            <el-time-picker v-model="addForm.dailyEndTime" placeholder="结束时间" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 150px" />
          </el-form-item>

          <!-- 每周执行时间 -->
          <el-form-item v-if="addForm.executeCycle === 'weekly'" label="执行时间" prop="weekDays">
            <div style="margin-bottom: 10px">
              <el-checkbox-group v-model="addForm.weekDays">
                <el-checkbox label="1">周一</el-checkbox>
                <el-checkbox label="2">周二</el-checkbox>
                <el-checkbox label="3">周三</el-checkbox>
                <el-checkbox label="4">周四</el-checkbox>
                <el-checkbox label="5">周五</el-checkbox>
                <el-checkbox label="6">周六</el-checkbox>
                <el-checkbox label="7">周日</el-checkbox>
              </el-checkbox-group>
            </div>
            <div style="margin-top: 10px">
              <el-time-picker v-model="addForm.dailyStartTime" placeholder="开始时间" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 150px; margin-right: 10px" />
              <span style="margin: 0 10px">至</span>
              <el-time-picker v-model="addForm.dailyEndTime" placeholder="结束时间" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 150px" />
            </div>
          </el-form-item>

          <!-- 每月执行时间 -->
          <el-form-item v-if="addForm.executeCycle === 'monthly'" label="执行时间" prop="monthDays">
            <div style="margin-bottom: 10px">
              <el-date-picker v-model="addForm.monthDays" type="dates" placeholder="选择每月的天数" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 300px" />
            </div>
            <div style="margin-top: 10px">
              <el-time-picker v-model="addForm.dailyStartTime" placeholder="开始时间" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 150px; margin-right: 10px" />
              <span style="margin: 0 10px">至</span>
              <el-time-picker v-model="addForm.dailyEndTime" placeholder="结束时间" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 150px" />
            </div>
          </el-form-item>

          <!-- 自定义周期 -->
          <el-form-item v-if="addForm.executeCycle === 'custom'" label="执行时间" prop="cycleTimeRange">
            <el-date-picker v-model="addForm.cycleTimeRange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 400px" />
          </el-form-item>

          <el-form-item label="选择班组" prop="teamId">
            <el-select v-model="addForm.teamId" placeholder="请选择巡检班组" style="width: 300px" filterable>
              <el-option v-for="team in teamList" :key="team.id" :label="team.teamName" :value="team.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="巡检路线" prop="routeId">
            <div class="route-selector">
              <el-select v-model="addForm.routeId" placeholder="请选择巡检路线" style="width: 300px" filterable @change="handleRouteChange">
                <el-option v-for="route in routeList" :key="route.routeCode" :label="route.routeName" :value="route.routeCode" />
              </el-select>
              <!--              <el-button
                type="text"
                @click="handleManageRoute"
                style="margin-left: 10px; color: #409eff"
              >
                + 管理路线
              </el-button> -->
            </div>
          </el-form-item>
        </div>

        <!-- 备注信息 -->
        <div class="form-section">
          <div class="section-title">
            <span>备注信息</span>
          </div>

          <el-form-item label="备注信息" prop="remark">
            <el-input v-model="addForm.remark" type="textarea" placeholder="请输入备注信息 (可选)" :rows="4" maxlength="200" show-word-limit />
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelAdd">取消</el-button>
        <el-button type="primary" @click="handleSubmitAdd" :loading="submitLoading">
          {{ isEditMode ? "更新" : "确认" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {
  getList,
  add,
  update,
  remove,
  getDetail,
  updateStatusBatch, getRouteList, exportExcel,
} from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import { formatDateTime } from "@/util/date";
import { downloadXls } from "@/util/util";
export default {
  name: "inspection-plan-manage",
  mixins: [crudMixins],
  components: {},
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      defaultParams: {
        businessType: "inspection-plan", // 巡检计划管理业务类型
      },
      // 弹窗相关数据
      addDialogVisible: false,
      submitLoading: false,
      exportLoading: false,
      isEditMode: false, // 是否为编辑模式
      currentEditId: null, // 当前编辑的记录ID
      // 多选相关数据
      selectedRows: [], // 选中的行数据
      teamList: [
        {
          id: "ddzx",
          teamName: "生产调度中心",
          teamNo: "ddzx",
        },
      ],
      routeList: [],
      addForm: {
        planName: "",
        executeCycle: "daily",
        teamId: "ddzx",
        routeId: "",
        remark: "",
        // 每天执行时间
        dailyStartTime: "00:00:00",
        dailyEndTime: "17:00:00",
        // 每周执行时间
        weekDays: [],
        // 每月执行时间
        monthDays: [],
        // 自定义周期
        cycleTimeRange: [],
        cycleStartTime: "",
        cycleEndTime: "",
      },
      addFormRules: {
        planName: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        executeCycle: [
          { required: true, message: "请选择执行周期", trigger: "change" },
        ],
        dailyStartTime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        dailyEndTime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        weekDays: [
          { required: true, message: "请选择执行日期", trigger: "change" },
        ],
        monthDays: [
          { required: true, message: "请选择执行日期", trigger: "change" },
        ],
        cycleTimeRange: [
          { required: true, message: "请选择时间范围", trigger: "change" },
        ],
        teamId: [
          { required: true, message: "请选择巡检班组", trigger: "change" },
        ],
        routeId: [
          { required: true, message: "请选择巡检路线", trigger: "change" },
        ],
      },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        menu: true,
        addBtn: false,
        delBtn: true,
        editBtn: false,
        viewBtn: true,
        searchMenuSpan: 6,
        selection: true, // 启用多选
        selectionFixed: true, // 固定选择列
        column: [
          {
            label: "计划名称",
            prop: "planName",
            overHidden: true,
            search: true,
            searchLabelWidth: 100,
            searchSpan: 6,
            searchPlaceholder: "请输入计划名称",
            rules: [
              {
                required: true,
                message: "请输入计划名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "执行周期",
            prop: "executeCycle",
            overHidden: true,
            search: false,
            dataType: 'string',
            type:'select',
            dicData: [
              { label: "每天", value: 1 },
              { label: "每周", value: 2 },
              { label: "每月", value: 3 },
              { label: "自定义周期", value: 4 },
            ],
          },
          {
            label: "巡检路线",
            prop: "inspectionRouteName",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.inspectionRouteName || "-";
            },
          },
          {
            label: "巡检班组",
            prop: "teamName",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.teamName || "-";
            },
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchLabelWidth: 80,
            showColumn: false,
            dataType: "string",
            dicData: [
              { label: "全部", value: "" },
              { label: "启用", value: "1" },
              { label: "禁用", value: "0" },
            ],
            slot: true,
          },
          {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            overHidden: true,
            search: false,
          },
          {
            label: "创建人",
            prop: "createName",
            overHidden: true,
            search: false,
            editDisabled: true,
            addDisabled: true,
            formatter: (row) => {
              return row.createName || "-";
            },
          },
          {
            label: "备注",
            prop: "remark",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.remark || "-";
            },
          },
          {
            ...searchTimeConfig,
            searchSpan: 12,
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
            hide: true,
          },
        ],
      },
    };
  },

  methods: {

    async handleExport () {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `巡检计划管理_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },

    // 加载巡检路线列表（弹窗下拉用：每次打开须重新请求，避免新增路线后仍显示缓存）
    async loadRouteList () {
      const response = await getRouteList({
        page: 1,
        size: 500,
      });
      const pageData = response.data && response.data.data;
      this.routeList = (pageData && pageData.records) || [];
    },

    // 执行周期变化处理
    handleCycleChange (value) {
      console.log("执行周期变化:", value);
      // 重置相关字段
      this.addForm.weekDays = [];
      this.addForm.monthDays = [];
      this.addForm.cycleTimeRange = [];
      this.addForm.dailyStartTime = "08:00:00";
      this.addForm.dailyEndTime = "17:00:00";
      if (value === "weekly") {
        this.addForm.weekDays = ["1", "3", "5"]; // 默认选择周一、三、五
      }
    },

    // 巡检路线变化处理
    handleRouteChange (value) {
      const selectedRoute = this.routeList.find(
        (route) => route.routeCode === value
      );
    },

    // 管理路线
    handleManageRoute () {
      this.$router.push({
        path: `/dispatched-personnel-track/InspectionRouteManage/index`,
      });
    },

    // 取消新增/编辑
    handleCancelAdd () {
      console.log(123);

      this.addDialogVisible = false;
      this.isEditMode = false;
      this.currentEditId = null;
      this.resetAddForm();
      setTimeout(() => {
        console.log(this.addForm.executeCycle, 'executeCycle');
      }, 2000);
    },

    // 重置新增表单
    resetAddForm () {
      this.addForm = {
        planName: "",
        executeCycle: "daily",
        teamId: "ddzx", // 默认选中巡检工单管理班
        routeId: "",
        remark: "",
        // 每天执行时间
        dailyStartTime: "08:30:00",
        dailyEndTime: "17:00:00",
        // 每周执行时间
        weekDays: [],
        // 每月执行时间
        monthDays: [],
        // 自定义周期
        cycleTimeRange: [],
        cycleStartTime: "",
        cycleEndTime: "",
      };
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate();
      });
    },

    // 提交新增/编辑
    handleSubmitAdd () {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          try {
            this.submitLoading = true;

            const formData = this.buildSubmitData();
            console.log("提交的数据:", formData);

            let response;
            if (this.isEditMode) {
              // 编辑模式
              formData.id = this.currentEditId;
              response = await update(formData);
            } else {
              // 新增模式
              response = await add(formData);
            }
            if (response && response.data.code === 200) {
              this.$message.success(
                this.isEditMode ? "编辑巡检计划成功" : "新增巡检计划成功"
              );
              this.addDialogVisible = false;
              this.resetAddForm();
              // 延迟重新加载数据，确保接口调用完成
              this.$nextTick(() => {
                this.refreshData();
              });
            }
          } finally {
            this.submitLoading = false;
          }

        } else {
          this.$message.error("请完善表单信息");
        }
      });
    },

    // 构建提交数据
    buildSubmitData () {
      const selectedTeam = this.teamList.find(
        (team) => team.id === this.addForm.teamId
      );
      const selectedRoute = this.routeList.find(
        (route) => route.routeCode === this.addForm.routeId
      );

      const baseData = {
        planName: this.addForm.planName,
        teamNo: selectedTeam ? selectedTeam.teamNo : "ddzx",
        teamName: selectedTeam ? selectedTeam.teamName : "生产调度中心",
        executeCycle: this.getExecuteCycleValue(),
        inspectionRouteCode: selectedRoute ? selectedRoute.routeCode : "",
        inspectionRouteName: selectedRoute ? selectedRoute.routeName : "",
        estimatedTime: selectedRoute.estimatedTime,
        totalDistance: selectedRoute.totalDistance,
        remark: this.addForm.remark,
      };
      baseData.dailyStartTime = this.addForm.dailyStartTime;
      baseData.dailyEndTime = this.addForm.dailyEndTime;
      // 根据执行周期添加特定字段
      // if (this.addForm.executeCycle === "daily") {
      //   baseData.cycleStartTime = this.addForm.dailyStartTime;
      //   baseData.cycleEndTime = this.addForm.dailyEndTime;
      // }
      if (this.addForm.executeCycle === "weekly") {
        baseData.weekDays = this.addForm.weekDays.join(",");
      } else if (this.addForm.executeCycle === "monthly") {
        baseData.monthDays = this.addForm.monthDays.join(",");
      } else if (this.addForm.executeCycle === "custom") {
        if (
          this.addForm.cycleTimeRange &&
          this.addForm.cycleTimeRange.length === 2
        ) {
          baseData.cycleStartTime = this.addForm.cycleTimeRange[0];
          baseData.cycleEndTime = this.addForm.cycleTimeRange[1];
        }
      }

      return baseData;
    },

    // 获取执行周期值
    getExecuteCycleValue () {
      const cycleMap = {
        daily: 1,
        weekly: 2,
        monthly: 3,
        custom: 4,
      };
      return cycleMap[this.addForm.executeCycle] || 1;
    },

    // 点击新增按钮
    async handleAddNew () {
      this.isEditMode = false;
      this.currentEditId = null;
      this.addDialogVisible = true;
      this.resetAddForm();
      await this.loadRouteList();
    },

    // 点击编辑按钮
    async handleEdit (row) {
      this.isEditMode = true;
      this.currentEditId = row.id;
      this.addDialogVisible = true;

      const response = await getDetail(row.id);
      // console.log("获取详情返回:", response);
      if (response && response.data) {
        const detailData = response.data;
        this.fillFormData(detailData.data);
      }
      await this.loadRouteList();
    },


    // 填充表单数据
    fillFormData (data) {
      // 先重置表单为默认值
      this.resetAddForm();

      // 填充基本数据
      this.addForm.planName = data.planName || "";
      this.addForm.executeCycle = this.getExecuteCycleKey(data.executeCycle);
      this.addForm.teamId = data.teamNo || "ddzx";
      this.addForm.routeId = data.inspectionRouteCode || "";
      this.addForm.remark = data.remark || "";

      // 填充时间相关数据
      this.addForm.dailyStartTime = data.dailyStartTime || "08:30:00";
      this.addForm.dailyEndTime = data.dailyEndTime || "17:00:00";
      // 填充周期相关数据
      if (data.weekDays) {
        this.addForm.weekDays = data.weekDays.split(",");
      }
      if (data.monthDays) {
        this.addForm.monthDays = data.monthDays.split(",");
      }
      if (data.cycleStartTime && data.cycleEndTime) {
        this.addForm.cycleTimeRange = [
          formatDateTime(data.cycleStartTime),
          formatDateTime(data.cycleEndTime),
        ];
        this.addForm.cycleStartTime = formatDateTime(data.cycleStartTime);
        this.addForm.cycleEndTime = formatDateTime(data.cycleEndTime);
      }

      console.log("填充后的表单数据:", this.addForm);
    },

    // 获取执行周期键名
    getExecuteCycleKey (value) {
      const cycleMap = {
        1: "daily",
        2: "weekly",
        3: "monthly",
        4: "custom",
      };
      return cycleMap[value] || "daily";
    },

    // 刷新数据
    refreshData () {
      this.loading = false;
      this.onLoad(this.page);
    },

    // 批量启用
    handleBatchEnable () {
      if (!this.ids) {
        this.$message.warning("请先选择要启用的记录");
        return;
      }

      this.$confirm(
        `确定要启用选中的记录吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await this.batchUpdateStatus(1, "启用");
        })

    },

    // 批量禁用
    handleBatchDisable () {
      if (!this.ids) {
        this.$message.warning("请先选择要禁用的记录");
        return;
      }

      this.$confirm(
        `确定要禁用选中的记录吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await this.batchUpdateStatus(0, "禁用");
        })
    },

    // 批量更新状态
    async batchUpdateStatus (status, actionName) {
      try {
        this.loading = true;
        const response = await updateStatusBatch({
          ids: this.ids,
          status: status,
        });
        if (response && response.data.code === 200) {
          this.$message.success(response.data.msg);
          this.onLoad(this.page);
        }
      } finally {
        this.selectionClear();
        this.loading = false;
      }
    },

    // 切换状态
    handleToggleStatus (row) {
      const newStatus = row.status === 1 ? "禁用" : "启用";
      const statusValue = newStatus === "启用" ? 1 : 0;

      this.$confirm(`确定要${newStatus}该巡检计划吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 调用批量状态更新接口
          const response = await updateStatusBatch({
            ids: row.id,
            status: statusValue,
          });

          // 立即结束加载状态
          this.loading = false;
          if (response && response.data.code === 200) {
            this.$message.success(response.data.msg);
            // 延迟刷新数据，确保状态更新完成
            this.$nextTick(() => {
              this.refreshData();
            });
          }
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

// 自定义搜索表单样式
::v-deep .avue-crud__search {
  .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  .el-input__inner {
    border-radius: 4px;
    border: 1px solid #dcdfe6;

    &:focus {
      border-color: #409eff;
    }
  }

  .el-button--primary {
    background-color: #409eff;
    border-color: #409eff;
  }

  .el-button--default {
    background-color: #f5f7fa;
    border-color: #dcdfe6;
    color: #606266;
  }
}

// 自定义表格样式
::v-deep .avue-crud__table {
  .el-table__header {
    th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
  }

  .el-table__row {
    &:hover {
      background-color: #f5f7fa;
    }
  }
}

// 状态标签样式
::v-deep .el-tag {
  border-radius: 4px;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 500;
}

// 操作按钮样式
::v-deep .el-button--text {
  padding: 0;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}

// 新增按钮容器
.add-button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;

  .el-button {
    margin-right: 0;
  }
}

// 弹窗表单样式
.add-form {
  .form-section {
    margin-bottom: 20px;

    .section-title {
      margin-bottom: 15px;
      font-size: 14px;
      font-weight: 600;
      color: #303133;

      .required {
        color: #f56c6c;
      }
    }
  }

  .route-selector {
    display: flex;
    align-items: center;
  }
}

// 弹窗底部按钮
.dialog-footer {
  text-align: right;

  .el-button {
    min-width: 80px;
  }
}

// 弹窗样式覆盖
::v-deep .el-dialog__wrapper {
  z-index: 3000 !important;
}

::v-deep .el-dialog {
  z-index: 3001 !important;
}

// 移除可能的遮罩层
::v-deep .el-dialog__wrapper .el-dialog {
  position: relative;
}

// 确保弹窗在最顶层
::v-deep .el-dialog__wrapper {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3000 !important;
}
</style>
